import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMechanicMe } from '../api/mechanicAuth.api';

const MechanicAuthContext = createContext(null);

export const MechanicAuthProvider = ({ children }) => {
  const [mechanic, setMechanic] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('mechanicToken'));
  const [loading, setLoading] = useState(!!localStorage.getItem('mechanicToken'));

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    getMechanicMe()
      .then((m) => setMechanic(m))
      .catch(() => { localStorage.removeItem('mechanicToken'); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const loginMechanic = useCallback((tokenStr, mechanicData) => {
    localStorage.setItem('mechanicToken', tokenStr);
    setToken(tokenStr);
    setMechanic(mechanicData);
  }, []);

  const logoutMechanic = useCallback(() => {
    localStorage.removeItem('mechanicToken');
    setToken(null);
    setMechanic(null);
  }, []);

  return (
    <MechanicAuthContext.Provider value={{ mechanic, token, loading, loginMechanic, logoutMechanic, isAuthenticated: !!token }}>
      {children}
    </MechanicAuthContext.Provider>
  );
};

export const useMechanicAuth = () => {
  const ctx = useContext(MechanicAuthContext);
  if (!ctx) throw new Error('useMechanicAuth must be used within MechanicAuthProvider');
  return ctx;
};
